import { TicketPool } from "@ticketingplatform/api/dist/ticketPool/__generated__/TicketPool";

import { TicketTemplateFormValues } from "./partials/TicketTemplateForm/types";

export const initialValues: TicketTemplateFormValues = {
  input: {
    name: null,
    ticketPools: [],
  },
};

export const ticketPoolFormFields: (keyof TicketPool)[] = [
  "name",
  "price",
  "quantity",
  "venueFee",
  "description",
  "maxTicketsPerOrder",
  "minTicketsPerOrder",
  "availableBeforeDays",
  "availableBeforeTime",
  "expireBeforeDays",
  "expireBeforeTime",
  "isAutoApprove",
  "isScannerOnly",
];
